export default __webpack_public_path__ + "efc961278a6df4e7cea1c3fe361ee79b.svg";